import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ContentGroup } from 'ui';
import { historySelector } from 'selectors/learn/contents';
import PageTitle from 'components/shared/PageTitle';
import Select from 'components/shared/select';
import ContentCard from '../../shared/LearnContentCard';
import * as sortOptions from './sortOptions';

class History extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedSortOption: sortOptions.MOST_RECENT_ACTIVITY };
    this.onSortChange = this.onSortChange.bind(this);
  }

  onSortChange(e) {
    this.setState({ selectedSortOption: e.target.value });
  }

  getContents() {
    const { contents } = this.props;
    const { selectedSortOption } = this.state;
    const { sort: compareFn } =
      sortOptions.historySortOptions[selectedSortOption];
    return contents.sort(compareFn);
  }

  render() {
    return (
      <>
        <PageTitle title={[t('learn.sidebar.history'), t('learn.title')]} />
        <ContentGroup
          className="LearnContentGroup"
          items={this.getContents()}
          title={t('content.groups.history')}
        >
          <ContentGroup.Action>
            <div>
              <span className="mr-8">{t('content.sort.prompt')}</span>
              <Select
                onChange={this.onSortChange}
                value={this.state.selectedSortOption}
              >
                {Object.entries(sortOptions.historySortOptions).map(
                  ([value, option]) => (
                    <option key={value} value={value}>
                      {option.label()}
                    </option>
                  ),
                )}
              </Select>
            </div>
          </ContentGroup.Action>
          <ContentGroup.Items
            render={content => (
              <ContentCard key={`${content.id}.${content.type}`} {...content} />
            )}
          />
        </ContentGroup>
      </>
    );
  }
}

const mapStateToProps = state => ({
  contents: historySelector(state),
});

export default connect(mapStateToProps)(History);
